<template>
  <v-card elevation="2" class="mb-4">
    <v-card-title>App Features</v-card-title>
    <v-card-text>
      <p class="mb-4">
        Features available to this customer based on their purchased products.
      </p>
      <v-data-table
        :headers="headers"
        :items="features"
        :loading="loading"
        :items-per-page="10"
      >
        <template v-slot:item.ShopifyProductId="{ item }">
          <a :href="`https://${storeUrl}/admin/products/${item.ShopifyProductId}`" target="_blank">
            {{ item.ShopifyProductId }}
          </a>
        </template>
        <template v-slot:item.CreatedAt="{ item }">
          {{ formatDate(item.CreatedAt) }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import fb from "@/main";
import moment from "moment";

export default {
  name: "CustomerFeatures",
  props: {
    shopifyCustomerId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      store: "soundpaint",
      loading: false,
      features: [],
      headers: [
        {
          text: "Feature",
          value: "Feature",
          align: "left",
        },
        {
          text: "Shopify Product ID",
          value: "ShopifyProductId",
          align: "left",
        },
        {
          text: "Purchased",
          value: "CreatedAt",
          align: "left",
        },
      ],
    };
  },
  computed: {
    storeUrl() {
      return "soundpaint.myshopify.com";
    },
  },
  watch: {
    shopifyCustomerId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getCustomerFeatures();
        }
      },
    },
  },
  methods: {
    formatDate(date) {
      return date ? moment(date).format("MMM D, YYYY") : "";
    },
    async getCustomerFeatures() {
      this.loading = true;
      try {
        const getCustomerFeaturesCall = fb.functions.httpsCallable("getCustomerFeatures");
        const { data: recordset } = await getCustomerFeaturesCall({
          store: this.store,
          shopifyCustomerId: this.shopifyCustomerId,
        });
        if (recordset && recordset.length) {
          this.features = recordset;
        } else {
          this.features = [];
        }
      } catch (error) {
        console.error(error);
        this.features = [];
      }
      this.loading = false;
    },
  },
};
</script>
